import { render, staticRenderFns } from "./netbank-login-identifier.pug?vue&type=template&id=34f8b060&scoped=true&lang=pug&external"
import script from "./netbank-login-identifier.js?vue&type=script&lang=js&external"
export * from "./netbank-login-identifier.js?vue&type=script&lang=js&external"
import style0 from "./netbank-login-identifier.scss?vue&type=style&index=0&id=34f8b060&prod&scoped=true&lang=scss&external"
import style1 from "../netbank-common/netbank-common.scss?vue&type=style&index=1&id=34f8b060&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f8b060",
  null
  
)

export default component.exports